export default function getResource(label) {
    const resources = {
        gotIt: 'Compris',
        undo: 'Annuler'
    };

    return resources[label];
}
